//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



export default {
  name: "entry",
  data() {
    return {
      ads_vpn_conf: this.get_ads('vpn'),
      ads_xyg_conf: this.get_ads('xyg'),
      ads_69av_conf: this.get_ads('69av'),
      cn_tmp_host: undefined,
    }
  },
  created() {
    this.$app.footer(false);
    this.$app.header(false);

    this.cn_tmp_host = this.$web_conf.cn_tmp_hosts[0]

  }
}
